import { SubscriptionPlanType } from "src/app/core/models/stripe.models";

/**
 * Canonical plan-tier predicates — the single source of truth for "which
 * SubscriptionPlanType values belong to which commercial tier".
 *
 * Before these existed, dashboard, settings, and the NgRx plan selectors
 * each kept their own drifted copies of these lists (each missing different
 * plans). Extend the sets here; never re-list plan types at call sites.
 */

const STARTER_PLANS: SubscriptionPlanType[] = [SubscriptionPlanType.Starter, SubscriptionPlanType.YearlyStarter];

const GROWTH_PLANS: SubscriptionPlanType[] = [SubscriptionPlanType.Growth, SubscriptionPlanType.YearlyGrowth];

const SALES_PRO_PLANS: SubscriptionPlanType[] = [
  SubscriptionPlanType.SalesPro,
  SubscriptionPlanType.MonthlySalesPro,
  SubscriptionPlanType.YearlySalesPro,
  SubscriptionPlanType.ProPlanTeamsSMB,
  SubscriptionPlanType.ProPlanTeamsEnt,
  SubscriptionPlanType.ProTeamsSMB,
  SubscriptionPlanType.ProTeamsEnt,
];

export function isFreemiumTier(plan: SubscriptionPlanType | null | undefined): boolean {
  return plan === SubscriptionPlanType.Freemium;
}

export function isStarterTier(plan: SubscriptionPlanType | null | undefined): boolean {
  return STARTER_PLANS.includes(plan);
}

/** Growth plans only — SalesPro/Teams plans are NOT growth (see isGrowthOrHigherTier). */
export function isGrowthTier(plan: SubscriptionPlanType | null | undefined): boolean {
  return GROWTH_PLANS.includes(plan);
}

/** SalesPro and all Teams flavors. */
export function isSalesProTier(plan: SubscriptionPlanType | null | undefined): boolean {
  return SALES_PRO_PLANS.includes(plan);
}

export function isGrowthOrHigherTier(plan: SubscriptionPlanType | null | undefined): boolean {
  return isGrowthTier(plan) || isSalesProTier(plan);
}
